import { type ActiveIntegration, type IntegrationFilter } from '../../types'

export const extractNameFiltersFromIntegrations = ( integrations?: ActiveIntegration[] ): IntegrationFilter[] => {
	return integrations
		? integrations.reduce( ( accumulator, integration ) => {
			const name = integration.integration?.name
			if ( !name ) {
				return accumulator
			}
			const id = name.toLowerCase()
			const existingName = accumulator.find( ( m ) => m.id === id )

			if ( !existingName ) {
				accumulator.push( {
					id,
					name,
				} )
			}

			return accumulator
		}, [] as IntegrationFilter[] )
		: []
}
